"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var dividerStyle = react_1.css({
    cursor: 'text',
});
var DropdownMenuDivider = function (_a) {
    var style = _a.style;
    return (react_1.jsx("div", { className: "rc-menu-item-divider", style: style, onClick: function (e) { return e.stopPropagation(); }, css: dividerStyle }));
};
exports.default = DropdownMenuDivider;
